import {Store} from '@reduxjs/toolkit';
import {RootState} from '../../hooks/store';
import {trackEvent} from '../../utils/mParticleTracking';
import {generateDateSelectedAttributes} from './generateDateSelectedAttributes';

export const trackDateSelectedEvent = ({
  store,
  isMobile,
  action,
}: {
  store: Store<RootState>;
  isMobile: boolean;
  action: 'click' | 'left arrow' | 'right arrow' | 'next available date button';
}) => {
  const dateSelectedAttributes = generateDateSelectedAttributes({
    state: store.getState(),
    isMobile,
  });
  dateSelectedAttributes.action = action;
  trackEvent({
    eventName: 'date_selected',
    eventAttributes: dateSelectedAttributes,
  });
};
